<template>
  <v-row>
    <v-col class="d-flex justify-space-between">
      <v-icon v-if="file && !loading" color="green" :class="(obligatorio == 'S' ? 'mt-n7' : 'mt-n2') + ' mr-1'">
        <!--<v-icon v-if="file && !loading" color="green" style="position: relative; top: -15px; margin-right: 10px;">-->
        mdi-check-bold
      </v-icon>
      <v-file-input outlined ref="file" v-model="file" clearable @change="handleFile()" :loading="loading"
        :disabled="loading" truncate-length="25" :prepend-icon="getIcon" :clear-icon="'mdi-trash-can-outline'"
        :label="titulo" :hint="obligatorio == 'S' ? 'Obligatorio' : ''" persistent-hint
        accept=".jpg, .jpeg, .png, .tif, .tiff, .pdf, .doc, .docx, .odt, .zip, .rar, .7z, .xls, .xlsx, .ods"
        :class="obligatorio == 'N' ? 'no-messages' : ''" @click="onClick($event)" />
    </v-col>
    <!-- <div v-if="file && !loading && !readonly">
      <v-icon class="file-download" @click="downloadDocument">mdi-download</v-icon>
    </div> -->
  </v-row>
</template>

<script>
import api from '@Base/services/auditoriaService';

export default {
  name: 'FileUploader',
  props: ['idCampo', 'idCombinacion', 'idSubsanarTipoDocumento', 'idSolicitud', 'idSolDocumento', 'idTipoDocumento', 'nombreArchivo', 'titulo', 'obligatorio', 'idNotificacion'],
  data() {
    return {
      idDocumento: this.idSolDocumento ? this.idSolDocumento : null,
      prevFile: this.nombreArchivo ? { name: this.nombreArchivo } : null,
      file: this.nombreArchivo ? { name: this.nombreArchivo } : null,
      loading: false,
      //success: false,
    }
  },
  computed: {
    getIcon() {
      return this.file ? '' : 'mdi-paperclip';
    },
  },
  methods: {
    onClick(event) {
      if (this.file) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    /*downloadDocument() {
      this.loading = true;
      api.getDocumento( this.idDocumento, ()=> {this.loading = false;}, ()=> {this.loading = false;});
    },*/
    handleFile() {
      if (this.loading) return;
      if (!this.file) {
        if (this.prevFile) {
          this.file = { name: this.prevFile.name };
        }
        this.borrarDocumento();
        return;
      }

      this.loading = true;
      let formData = new FormData();

      formData.append('file', this.file ? this.file : null);
      formData.append('idSolicitud', this.idSolicitud);
      if (this.idCampo) {
        formData.append('idAudMaestraCampos', this.idCampo);
      }
      if (this.idSubsanarTipoDocumento) {
        formData.append('idAudSubsanarTipoDocumento', this.idSubsanarTipoDocumento);
      }
      if (this.idCombinacion) {
        formData.append('idCombinacionDocSeleccionada', this.idCombinacion);
      }

      if (this.idNotificacion) {
        formData.append('idNotificacion', this.idNotificacion);
      }
      formData.append('tipoDocumento', this.idTipoDocumento);
      formData.append('fileName', this.file ? this.file.name : '');
      formData.append('mimeType', this.file ? this.file.type : '');

      api.subirDocumento(formData,
        res => {
          this.loading = false;

          this.prevFile = { name: this.file.name };
          this.idDocumento = res;
          if (this.idCampo && this.idSubsanarTipoDocumento && this.idCombinacion) {
            this.$emit('uploaded', { idCampo: this.idCampo, idCombinacion: this.idCombinacion, idSubsaTipoDocumento: this.idSubsanarTipoDocumento, idSolDocumento: this.idDocumento, nombreArchivo: this.file.name });
          } else {
            this.$emit('uploaded', { idSolDocumento: this.idDocumento, nombreArchivo: this.file.name });
          }
        },
        error => {
          this.loading = false;
          this.idDocumento = null;
          this.prevFile = null;
          this.file = null;
        });
    },
    borrarDocumento() {
      this.loading = true;

      api.borrarDocumento(this.idDocumento,
        res => {
          this.loading = false;

          this.file = null;
          this.prevFile = null;
          this.idDocumento = null;

          this.$emit('deleted', { idCampo: this.idCampo, idCombinacion: this.idCombinacion, idSubsaTipoDocumento: this.idSubsanarTipoDocumento, idSolDocumento: null, nombreArchivo: null });
        },
        error => {
          this.loading = false;
        });
    }
  }
}
</script>

<style scoped>
.v-file-input>.v-messages__message {
  color: red;
}

.file-download {
  color: #124D91;
  cursor: pointer;
}
</style>